import React, { useEffect, useState } from 'react'

import {
  DehydratedState,
  QueryClient,
  QueryClientProvider,
  Hydrate,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useRouter } from 'next/router'
import { environment } from '@/shared/consts/environment'

interface ReactQueryProviderProps {
  children: React.ReactNode
  dehydratedState?: DehydratedState
}

export const ReactQueryProvider = ({
  children,
  dehydratedState,
}: ReactQueryProviderProps) => {
  const [showDevTools, setShowDevTools] = useState(false)
  const { query } = useRouter()

  useEffect(() => {
    if (environment.env === 'production') return
    const { RQDevtools } = query
    if (RQDevtools) {
      setShowDevTools(true)
    }
  }, [query])

  // This ensures that data is not shared
  // between different users and requests
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
            staleTime: 1000 * 60 * 5, // 5 minutes
          },
        },
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>
        {children}
        {showDevTools && <ReactQueryDevtools initialIsOpen={showDevTools} />}
      </Hydrate>
    </QueryClientProvider>
  )
}
